import { Box, Button, Grid, Typography } from "@mui/material";
import { getInvestmentFixedClose, getInvestmentFixedCurrentlyList, investmentFixedClose } from "store/slices/investment/investmentSlice";
import { useEffect, useState } from "react";

import { DefaultUrlWeb } from "config/Configuration";
import { LoadingButton } from "@mui/lab";
import NumberFormats from "components/NumberFormats";
import { setStockNumberColor } from "utils/helpers/numbers";
import useDispatch from "hooks/useDispatch";
import useIsMobileView from "hooks/useIsMobileView";

export default function ConfirmCloseInvestmentDetails({ onClose, data }) {
  const isMobileView = useIsMobileView();
  const dispatch = useDispatch();

  const [investmentFixed, setInvestmentFixed] = useState();
  const [loading, setLoading] = useState(false);

  const handleInvestmentFixedClose = async () => {
    setLoading(false);
    const body = {
      id: investmentFixed?.id,
    };

    try {
      await dispatch(
        investmentFixedClose(body),
        "درخواست شما با موفقیت ارسال شد"
      );

      await dispatch(getInvestmentFixedCurrentlyList(body));

      onClose();
    } catch (e) {
      throw e;
    }
    setLoading(true);
  };

  const handleGetInvestmentFixedClose = async () => {
    const { payload } = await dispatch(
      getInvestmentFixedClose(data?.unitTradeId)
    );

    setInvestmentFixed(payload?.data?.data);
  };

  useEffect(() => {
    handleGetInvestmentFixedClose();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box px={3}>
      <Grid container spacing={1}>
        <Grid item xs={12} pb={2}>
          <Typography
            dir="rtl"
            color="text.main"
            variant="h6"
            fontWeight={400}
            pt={2}
            lineHeight={2}
          >
            شما در حال بستن صندوق سرمایه گذاری ثابت خود هستید. در صورت بستن صندوق پیش از موعد پایان قرارداد، اگر صندوق در سود باشد، فقط اصل سرمایه به شما بازگردانده می‌شود. همچنین اگر صندوق در ضرر باشد، میزان ضرر به عهده شما خواهد بود.
          </Typography>
          <Typography
            color="text.main"
            variant={isMobileView ? "h6" : "h5"}
            fontWeight={500}
            display="flex"
            component="span"
            mt={2}
            dir="rtl"
          >
            <Typography color="error.main" fontWeight={500}>
              توجه :
              <Typography
                component="span"
                color="text.main"
                variant={isMobileView ? "h6" : "h5"}
                fontWeight={500}
                pr={0.5}
              >
                سود یا زیان نمایش داده شده مربوط به روز قبل می باشد.
              </Typography>
            </Typography>{" "}
          </Typography>
        </Grid>

        <Grid item xs={12} px={2}>
          <Box display="flex" justifyContent="space-between" pb={3}>
            <Typography variant="h5" color="text.secondary">
              Amount
            </Typography>

            <Box display="flex" alignItems="center">
              <img
                src={DefaultUrlWeb + investmentFixed?.coinImageUrl}
                alt=""
                width={25}
                height={25}
              />
              <Typography
                variant="h6"
                color="text.main"
                pl={1}
                fontWeight={400}
              >
                <Typography variant="h6" fontWeight={400}>
                  <NumberFormats value={investmentFixed?.amount} />{" "}
                  {investmentFixed?.coinName}
                </Typography>
                <Typography variant="h6" fontWeight={400}>
                  {investmentFixed?.amountUnit}
                </Typography>
              </Typography>
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-between" pb={3}>
            <Typography variant="h5" color="text.secondary">
              Profit / Lost
            </Typography>

            <Box display="flex" alignItems="center">
              <Typography
                variant="h6"
                color="text.main"
                pl={1}
                fontWeight={400}
              >
                <Typography
                  variant="h6"
                  color={
                    setStockNumberColor(investmentFixed?.profitOrLoss)
                      ?.color
                  }
                  fontWeight={400}
                >
                  <NumberFormats value={investmentFixed?.profitOrLoss} />{" "}
                  {investmentFixed?.coinName}
                </Typography>
              </Typography>
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-between" pb={3}>
            <Typography variant="h5" color="text.secondary">
              Total
            </Typography>

            <Box display="flex" alignItems="center">
              <Typography
                variant="h6"
                color="text.main"
                pl={1}
                fontWeight={400}
              >
                <Typography variant="h6" fontWeight={400}>
                  <NumberFormats value={investmentFixed?.total} />{" "}
                  {investmentFixed?.coinName}
                </Typography>
              </Typography>
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-between" pt={2} pb={3}>
            <Typography variant="h5" color="text.secondary">
              Date & Time
            </Typography>

            <Typography variant="h5" color="text.secondary">
              {investmentFixed?.date}
              {investmentFixed?.time}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} pb={2}>
          <Grid container spacing={3} px={isMobileView ? 0 : 4}>
            <Grid item xs={6}>
              <Button color="info" fullWidth onClick={onClose}>
                Cancel
              </Button>
            </Grid>

            <Grid item xs={6}>
              <LoadingButton
                variant="contained"
                type="submit"
                fullWidth
                loading={loading}
                color="error"
                onClick={handleInvestmentFixedClose}
              >
                End / Close
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
